/**
 *@韩语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: '이 비디오에 관심이 없습니까? %second%',
  _switch_one: '바꾸기',
  _next_reward_text: '얻을 수있는 다른 동영상보기',
  _next_reward_button: '지금보기',
  _just_for_you: 'Just for you', // 没有这个语言
}